import { render, staticRenderFns } from "./TablePiutang.vue?vue&type=template&id=b3813b9c"
import script from "./TablePiutang.vue?vue&type=script&lang=js"
export * from "./TablePiutang.vue?vue&type=script&lang=js"
import style0 from "./TablePiutang.vue?vue&type=style&index=0&id=b3813b9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports